<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-12">
          <div class="card trainer-builder-header">
            <div class="card-header trainer-card-header">
              <div class="row align-items-center">
                <div class="col-sm-6">
                  <h4 class="card-title trainer-title">
                    <i class="nc-icon nc-settings-gear-65"></i>
                    Constructor de Planes
                  </h4>
                  <p class="card-category trainer-subtitle">
                    Crea y gestiona planes de entrenamiento personalizados
                  </p>
                </div>
                <div class="col-sm-6 text-right">
                  <button class="btn btn-light trainer-btn-new" @click="startNewWorkout">
                    <i class="nc-icon nc-simple-add"></i>
                    Nuevo Plan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estadísticas -->
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-paper text-primary"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Planes Creados</p>
                    <p class="card-title trainer-number">{{ workoutPlans.length }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-user-run text-success"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Planes Activos</p>
                    <p class="card-title trainer-number">{{ activePlans }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-favourite-28 text-warning"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Plantillas</p>
                    <p class="card-title trainer-number">{{ templates }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-lg-3 col-md-6">
          <div class="card card-stats trainer-stats-card">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center">
                    <i class="nc-icon nc-chart-pie-36 text-info"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">Tasa Completado</p>
                    <p class="card-title trainer-number">87%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Constructor Activo -->
      <div class="row" v-if="currentWorkout">
        <div class="col-lg-8">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">{{ currentWorkout.name || 'Nuevo Plan de Entrenamiento' }}</h6>
              <div class="card-tools">
                <button class="btn btn-sm btn-outline-success" @click="saveWorkout">
                  <i class="nc-icon nc-check-2"></i> Guardar
                </button>
                <button class="btn btn-sm btn-outline-secondary" @click="currentWorkout = null">
                  <i class="nc-icon nc-simple-remove"></i> Cerrar
                </button>
              </div>
            </div>
            <div class="card-body">
              <!-- Información del Plan -->
              <div class="trainer-workout-info">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Nombre del Plan</label>
                      <input type="text" class="form-control" v-model="currentWorkout.name" placeholder="Ej: Plan Fuerza Principiante">
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Duración (semanas)</label>
                      <select class="form-control" v-model="currentWorkout.duration">
                        <option value="4">4 semanas</option>
                        <option value="6">6 semanas</option>
                        <option value="8">8 semanas</option>
                        <option value="12">12 semanas</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Nivel</label>
                      <select class="form-control" v-model="currentWorkout.level">
                        <option value="principiante">Principiante</option>
                        <option value="intermedio">Intermedio</option>
                        <option value="avanzado">Avanzado</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Objetivo</label>
                      <select class="form-control" v-model="currentWorkout.goal">
                        <option value="fuerza">Fuerza</option>
                        <option value="hipertrofia">Hipertrofia</option>
                        <option value="resistencia">Resistencia</option>
                        <option value="perdida_peso">Pérdida de Peso</option>
                        <option value="rehabilitacion">Rehabilitación</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Días por Semana</label>
                      <select class="form-control" v-model="currentWorkout.daysPerWeek">
                        <option value="3">3 días</option>
                        <option value="4">4 días</option>
                        <option value="5">5 días</option>
                        <option value="6">6 días</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Descripción</label>
                  <textarea class="form-control" v-model="currentWorkout.description" rows="2" placeholder="Descripción del plan..."></textarea>
                </div>
              </div>

              <!-- Días de Entrenamiento -->
              <div class="trainer-workout-days">
                <h6 class="mb-3">Días de Entrenamiento</h6>
                <div class="trainer-days-tabs">
                  <button 
                    v-for="day in currentWorkout.days" 
                    :key="day.id"
                    class="btn btn-sm"
                    :class="activeDay === day.id ? 'trainer-btn-primary' : 'btn-outline-secondary'"
                    @click="activeDay = day.id"
                  >
                    {{ day.name }}
                  </button>
                  <button class="btn btn-sm btn-outline-success" @click="addDay">
                    <i class="nc-icon nc-simple-add"></i> Añadir Día
                  </button>
                </div>

                <!-- Contenido del Día Activo -->
                <div v-if="activeDayData" class="trainer-day-content">
                  <div class="trainer-day-header">
                    <div class="row">
                      <div class="col-md-8">
                        <input type="text" class="form-control" v-model="activeDayData.name" placeholder="Nombre del día">
                      </div>
                      <div class="col-md-4">
                        <select class="form-control" v-model="activeDayData.focus">
                          <option value="full_body">Cuerpo Completo</option>
                          <option value="upper_body">Tren Superior</option>
                          <option value="lower_body">Tren Inferior</option>
                          <option value="push">Push</option>
                          <option value="pull">Pull</option>
                          <option value="legs">Piernas</option>
                          <option value="cardio">Cardio</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <!-- Ejercicios del Día -->
                  <div class="trainer-exercises-list">
                    <div v-for="(exercise, index) in activeDayData.exercises" :key="index" class="trainer-exercise-item">
                      <div class="trainer-exercise-drag">
                        <i class="nc-icon nc-grid-45"></i>
                      </div>
                      <div class="trainer-exercise-info">
                        <strong>{{ exercise.name }}</strong>
                        <br><small>{{ exercise.category }}</small>
                      </div>
                      <div class="trainer-exercise-params">
                        <input type="number" class="form-control form-control-sm" v-model="exercise.sets" placeholder="Series" min="1">
                        <input type="number" class="form-control form-control-sm" v-model="exercise.reps" placeholder="Reps" min="1">
                        <input type="number" class="form-control form-control-sm" v-model="exercise.weight" placeholder="Peso (kg)">
                        <input type="number" class="form-control form-control-sm" v-model="exercise.rest" placeholder="Descanso (seg)" min="30">
                      </div>
                      <div class="trainer-exercise-actions">
                        <button class="btn btn-sm btn-outline-danger" @click="removeExercise(index)">
                          <i class="nc-icon nc-simple-remove"></i>
                        </button>
                      </div>
                    </div>
                    
                    <button class="btn btn-outline-primary w-100" @click="showExerciseSelector = true">
                      <i class="nc-icon nc-simple-add"></i> Añadir Ejercicio
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Panel de Herramientas -->
        <div class="col-lg-4">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Herramientas</h6>
            </div>
            <div class="card-body">
              <!-- Plantillas -->
              <div class="trainer-templates">
                <h6>Plantillas Rápidas</h6>
                <div class="trainer-template-list">
                  <div v-for="template in quickTemplates" :key="template.id" class="trainer-template-item" @click="applyTemplate(template)">
                    <i :class="template.icon"></i>
                    <div>
                      <strong>{{ template.name }}</strong>
                      <br><small>{{ template.description }}</small>
                    </div>
                  </div>
                </div>
              </div>

              <hr>

              <!-- Estadísticas del Plan -->
              <div class="trainer-plan-stats">
                <h6>Estadísticas del Plan</h6>
                <div class="trainer-stat-item">
                  <span>Total Ejercicios:</span>
                  <strong>{{ totalExercises }}</strong>
                </div>
                <div class="trainer-stat-item">
                  <span>Tiempo Estimado:</span>
                  <strong>{{ estimatedTime }} min</strong>
                </div>
                <div class="trainer-stat-item">
                  <span>Grupos Musculares:</span>
                  <strong>{{ muscleGroups }}</strong>
                </div>
              </div>

              <hr>

              <!-- Acciones -->
              <div class="trainer-actions">
                <button class="btn trainer-btn-primary w-100 mb-2" @click="previewWorkout">
                  <i class="nc-icon nc-zoom-split"></i> Vista Previa
                </button>
                <button class="btn btn-outline-info w-100 mb-2" @click="saveAsTemplate">
                  <i class="nc-icon nc-favourite-28"></i> Guardar como Plantilla
                </button>
                <button class="btn btn-outline-warning w-100" @click="duplicateWorkout">
                  <i class="nc-icon nc-single-copy-04"></i> Duplicar Plan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Lista de Planes Existentes -->
      <div class="row" v-if="!currentWorkout">
        <div class="col-12">
          <div class="card trainer-card">
            <div class="card-header">
              <h6 class="card-title">Mis Planes de Entrenamiento</h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div v-for="plan in workoutPlans" :key="plan.id" class="col-lg-4 col-md-6 mb-4">
                  <div class="trainer-plan-card">
                    <div class="trainer-plan-header">
                      <h6>{{ plan.name }}</h6>
                      <div class="trainer-plan-badges">
                        <span class="badge trainer-badge-level" :class="getLevelClass(plan.level)">
                          {{ plan.level }}
                        </span>
                        <span class="badge trainer-badge-goal">{{ plan.goal }}</span>
                      </div>
                    </div>
                    <div class="trainer-plan-content">
                      <p>{{ plan.description }}</p>
                      <div class="trainer-plan-meta">
                        <div class="trainer-meta-item">
                          <i class="nc-icon nc-calendar-60"></i>
                          <span>{{ plan.duration }} semanas</span>
                        </div>
                        <div class="trainer-meta-item">
                          <i class="nc-icon nc-time-alarm"></i>
                          <span>{{ plan.daysPerWeek }} días/semana</span>
                        </div>
                        <div class="trainer-meta-item">
                          <i class="nc-icon nc-user-run"></i>
                          <span>{{ plan.assignedClients }} clientes</span>
                        </div>
                      </div>
                    </div>
                    <div class="trainer-plan-actions">
                      <button class="btn btn-sm btn-outline-primary" @click="editPlan(plan)">
                        <i class="nc-icon nc-settings-gear-65"></i> Editar
                      </button>
                      <button class="btn btn-sm btn-outline-success" @click="assignPlan(plan)">
                        <i class="nc-icon nc-user-run"></i> Asignar
                      </button>
                      <button class="btn btn-sm btn-outline-info" @click="duplicatePlan(plan)">
                        <i class="nc-icon nc-single-copy-04"></i> Copiar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Selector de Ejercicios -->
    <div class="modal" v-if="showExerciseSelector" @click="showExerciseSelector = false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Seleccionar Ejercicio</h5>
            <button type="button" class="close" @click="showExerciseSelector = false">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <input type="text" class="form-control mb-3" placeholder="Buscar ejercicio..." v-model="exerciseSearch">
              </div>
              <div class="col-md-6">
                <select class="form-control mb-3" v-model="exerciseCategoryFilter">
                  <option value="">Todas las categorías</option>
                  <option value="Fuerza">Fuerza</option>
                  <option value="Cardio">Cardio</option>
                  <option value="Flexibilidad">Flexibilidad</option>
                  <option value="Funcional">Funcional</option>
                </select>
              </div>
            </div>
            <div class="trainer-exercise-selector">
              <div v-for="exercise in filteredAvailableExercises" :key="exercise.id" class="trainer-selectable-exercise" @click="addExerciseToDay(exercise)">
                <img :src="exercise.image" :alt="exercise.name" v-if="exercise.image" class="trainer-exercise-thumb">
                <div class="trainer-exercise-placeholder-thumb" v-else>
                  <i class="nc-icon nc-image"></i>
                </div>
                <div class="trainer-exercise-details">
                  <strong>{{ exercise.name }}</strong>
                  <br><small>{{ exercise.category }}</small>
                  <br><small class="text-muted">{{ exercise.muscles.join(', ') }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorkoutBuilder',
  data() {
    return {
      currentWorkout: null,
      activeDay: null,
      showExerciseSelector: false,
      exerciseSearch: '',
      exerciseCategoryFilter: '',
      workoutPlans: [
        {
          id: 1,
          name: 'Plan Fuerza Principiante',
          description: 'Plan básico de fuerza para principiantes, enfocado en movimientos fundamentales.',
          level: 'principiante',
          goal: 'fuerza',
          duration: 8,
          daysPerWeek: 3,
          assignedClients: 5,
          status: 'activo'
        },
        {
          id: 2,
          name: 'Hipertrofia Intermedio',
          description: 'Programa de hipertrofia para atletas intermedios con experiencia previa.',
          level: 'intermedio',
          goal: 'hipertrofia',
          duration: 12,
          daysPerWeek: 4,
          assignedClients: 8,
          status: 'activo'
        },
        {
          id: 3,
          name: 'Plan Pérdida de Peso',
          description: 'Combinación de entrenamiento de fuerza y cardio para pérdida de peso.',
          level: 'principiante',
          goal: 'perdida_peso',
          duration: 6,
          daysPerWeek: 5,
          assignedClients: 12,
          status: 'activo'
        }
      ],
      quickTemplates: [
        {
          id: 1,
          name: 'Push/Pull/Legs',
          description: 'División clásica de 3 días',
          icon: 'nc-icon nc-settings-gear-65'
        },
        {
          id: 2,
          name: 'Full Body',
          description: 'Entrenamiento completo',
          icon: 'nc-icon nc-user-run'
        },
        {
          id: 3,
          name: 'HIIT Cardio',
          description: 'Alta intensidad',
          icon: 'nc-icon nc-time-alarm'
        }
      ],
      availableExercises: [
        {
          id: 1,
          name: 'Press de Banca',
          category: 'Fuerza',
          muscles: ['Pectorales', 'Tríceps'],
          image: '/static/img/tables/agenda.png'
        },
        {
          id: 2,
          name: 'Sentadillas',
          category: 'Fuerza',
          muscles: ['Cuádriceps', 'Glúteos'],
          image: '/static/img/tables/evernote.png'
        },
        {
          id: 3,
          name: 'Peso Muerto',
          category: 'Fuerza',
          muscles: ['Isquiotibiales', 'Glúteos', 'Espalda'],
          image: null
        },
        {
          id: 4,
          name: 'Dominadas',
          category: 'Fuerza',
          muscles: ['Dorsales', 'Bíceps'],
          image: '/static/img/tables/stylus.jpg'
        }
      ]
    }
  },
  computed: {
    activePlans() {
      return this.workoutPlans.filter(plan => plan.status === 'activo').length;
    },
    templates() {
      return this.workoutPlans.filter(plan => plan.isTemplate).length;
    },
    activeDayData() {
      if (!this.currentWorkout || !this.activeDay) return null;
      return this.currentWorkout.days.find(day => day.id === this.activeDay);
    },
    totalExercises() {
      if (!this.currentWorkout) return 0;
      return this.currentWorkout.days.reduce((total, day) => total + day.exercises.length, 0);
    },
    estimatedTime() {
      if (!this.currentWorkout) return 0;
      // Estimación basada en ejercicios y descansos
      return this.totalExercises * 4; // 4 minutos por ejercicio promedio
    },
    muscleGroups() {
      if (!this.currentWorkout) return 0;
      const muscles = new Set();
      this.currentWorkout.days.forEach(day => {
        day.exercises.forEach(exercise => {
          exercise.muscles?.forEach(muscle => muscles.add(muscle));
        });
      });
      return muscles.size;
    },
    filteredAvailableExercises() {
      let filtered = this.availableExercises;
      
      if (this.exerciseSearch) {
        filtered = filtered.filter(exercise => 
          exercise.name.toLowerCase().includes(this.exerciseSearch.toLowerCase())
        );
      }
      
      if (this.exerciseCategoryFilter) {
        filtered = filtered.filter(exercise => exercise.category === this.exerciseCategoryFilter);
      }
      
      return filtered;
    }
  },
  methods: {
    startNewWorkout() {
      this.currentWorkout = {
        name: '',
        description: '',
        level: 'principiante',
        goal: 'fuerza',
        duration: 8,
        daysPerWeek: 3,
        days: [
          {
            id: 1,
            name: 'Día 1',
            focus: 'full_body',
            exercises: []
          }
        ]
      };
      this.activeDay = 1;
    },
    addDay() {
      const newId = Math.max(...this.currentWorkout.days.map(d => d.id)) + 1;
      this.currentWorkout.days.push({
        id: newId,
        name: `Día ${newId}`,
        focus: 'full_body',
        exercises: []
      });
      this.activeDay = newId;
    },
    addExerciseToDay(exercise) {
      if (this.activeDayData) {
        this.activeDayData.exercises.push({
          ...exercise,
          sets: 3,
          reps: 10,
          weight: 0,
          rest: 60
        });
      }
      this.showExerciseSelector = false;
    },
    removeExercise(index) {
      if (this.activeDayData) {
        this.activeDayData.exercises.splice(index, 1);
      }
    },
    getLevelClass(level) {
      const classes = {
        'principiante': 'badge-success',
        'intermedio': 'badge-warning',
        'avanzado': 'badge-danger'
      };
      return classes[level] || 'badge-secondary';
    },
    editPlan(plan) {
      this.currentWorkout = { ...plan };
      this.activeDay = this.currentWorkout.days?.[0]?.id || null;
    },
    assignPlan(plan) {
      this.$swal.fire({
        title: 'Asignar Plan',
        text: `Asignar "${plan.name}" a un cliente`,
        confirmButtonColor: '#9ACD32'
      });
    },
    duplicatePlan(plan) {
      this.$swal.fire({
        title: 'Plan Duplicado',
        text: `"${plan.name}" ha sido duplicado`,
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    saveWorkout() {
      this.$swal.fire({
        title: 'Plan Guardado',
        text: 'El plan de entrenamiento ha sido guardado exitosamente',
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    previewWorkout() {
      this.$swal.fire({
        title: 'Vista Previa del Plan',
        text: 'Funcionalidad de vista previa en desarrollo',
        icon: 'info',
        confirmButtonColor: '#9ACD32'
      });
    },
    saveAsTemplate() {
      this.$swal.fire({
        title: 'Guardar como Plantilla',
        text: 'Plan guardado como plantilla reutilizable',
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    duplicateWorkout() {
      this.$swal.fire({
        title: 'Plan Duplicado',
        text: 'Se ha creado una copia del plan actual',
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    },
    applyTemplate(template) {
      this.$swal.fire({
        title: 'Plantilla Aplicada',
        text: `Plantilla "${template.name}" aplicada al plan actual`,
        icon: 'success',
        confirmButtonColor: '#9ACD32'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  --trainer-primary: #9ACD32;
  --trainer-secondary: #7CB342;
  --trainer-accent: #8BC34A;
  --trainer-dark: #689F38;
  --trainer-light: #DCEDC8;
  --trainer-bg: #F1F8E9;
}

.trainer-builder-header {
  background: linear-gradient(135deg, var(--trainer-primary), var(--trainer-secondary));
  color: white;
  border: none;
  box-shadow: 0 4px 20px 0px rgba(154, 205, 50, 0.14), 0 7px 10px -5px rgba(154, 205, 50, 0.4);
  
  .trainer-card-header {
    background: transparent;
    border: none;
  }
  
  .trainer-title {
    color: white;
    font-weight: 500;
    margin-bottom: 5px;
    
    i {
      margin-right: 10px;
    }
  }
  
  .trainer-subtitle {
    color: rgba(255,255,255,0.8);
    margin: 0;
  }
  
  .trainer-btn-new {
    border: 2px solid rgba(255,255,255,0.3);
    color: white;
    
    &:hover {
      background: rgba(255,255,255,0.1);
      border-color: rgba(255,255,255,0.5);
    }
  }
}

.trainer-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
  
  .card-header {
    background: var(--trainer-bg);
    border-bottom: 1px solid #dee2e6;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .card-title {
      color: var(--trainer-dark);
      font-weight: 600;
      margin: 0;
    }
    
    .card-tools {
      display: flex;
      gap: 8px;
    }
  }
}

.trainer-stats-card {
  border: none;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 25px 0 rgba(0,0,0,0.15);
    transform: translateY(-2px);
  }
  
  .trainer-number {
    font-size: 24px;
    font-weight: 700;
    color: var(--trainer-dark);
  }
}

.trainer-workout-info {
  background: var(--trainer-bg);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 25px;
}

.trainer-days-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.trainer-day-content {
  border: 2px solid var(--trainer-light);
  border-radius: 8px;
  padding: 20px;
}

.trainer-day-header {
  margin-bottom: 20px;
}

.trainer-exercise-item {
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 10px;
  
  .trainer-exercise-drag {
    color: #ccc;
    margin-right: 15px;
    cursor: move;
  }
  
  .trainer-exercise-info {
    flex: 1;
    margin-right: 15px;
  }
  
  .trainer-exercise-params {
    display: flex;
    gap: 8px;
    margin-right: 15px;
    
    input {
      width: 80px;
    }
  }
}

.trainer-plan-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    transform: translateY(-2px);
  }
  
  .trainer-plan-header {
    margin-bottom: 15px;
    
    h6 {
      color: var(--trainer-dark);
      font-weight: 600;
      margin-bottom: 10px;
    }
    
    .trainer-plan-badges {
      display: flex;
      gap: 8px;
      
      .trainer-badge-level {
        font-size: 11px;
        padding: 4px 8px;
      }
      
      .trainer-badge-goal {
        background: var(--trainer-primary);
        color: white;
        font-size: 11px;
        padding: 4px 8px;
      }
    }
  }
  
  .trainer-plan-content {
    flex: 1;
    margin-bottom: 15px;
    
    p {
      color: #666;
      font-size: 14px;
      line-height: 1.5;
    }
    
    .trainer-plan-meta {
      .trainer-meta-item {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        font-size: 13px;
        color: #666;
        
        i {
          margin-right: 8px;
          color: var(--trainer-primary);
        }
      }
    }
  }
  
  .trainer-plan-actions {
    display: flex;
    gap: 8px;
    
    .btn {
      flex: 1;
      font-size: 12px;
      padding: 6px 8px;
    }
  }
}

.trainer-templates {
  margin-bottom: 20px;
  
  h6 {
    color: var(--trainer-dark);
    margin-bottom: 15px;
  }
  
  .trainer-template-item {
    display: flex;
    align-items: center;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: var(--trainer-light);
    }
    
    i {
      font-size: 20px;
      color: var(--trainer-primary);
      margin-right: 12px;
    }
    
    strong {
      color: var(--trainer-dark);
    }
    
    small {
      color: #666;
    }
  }
}

.trainer-plan-stats {
  .trainer-stat-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    
    span {
      color: #666;
    }
    
    strong {
      color: var(--trainer-dark);
    }
  }
}

.trainer-exercise-selector {
  max-height: 400px;
  overflow-y: auto;
  
  .trainer-selectable-exercise {
    display: flex;
    align-items: center;
    padding: 15px;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: var(--trainer-light);
      border-color: var(--trainer-primary);
    }
    
    .trainer-exercise-thumb,
    .trainer-exercise-placeholder-thumb {
      width: 50px;
      height: 50px;
      margin-right: 15px;
      border-radius: 6px;
    }
    
    .trainer-exercise-thumb {
      object-fit: cover;
    }
    
    .trainer-exercise-placeholder-thumb {
      background: #f8f9fa;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ccc;
    }
    
    .trainer-exercise-details {
      flex: 1;
      
      strong {
        color: var(--trainer-dark);
      }
      
      small {
        color: #666;
      }
    }
  }
}

.trainer-btn-primary {
  background: var(--trainer-primary);
  border-color: var(--trainer-primary);
  color: white;
  
  &:hover {
    background: var(--trainer-secondary);
    border-color: var(--trainer-secondary);
  }
}

.form-control {
  border: 2px solid #e9ecef;
  border-radius: 6px;
  
  &:focus {
    border-color: var(--trainer-primary);
    box-shadow: 0 0 0 0.2rem rgba(154, 205, 50, 0.25);
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  
  .modal-dialog {
    background: white;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow-y: auto;
  }
  
  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #dee2e6;
    
    .modal-title {
      color: var(--trainer-dark);
      font-weight: 600;
    }
    
    .close {
      background: none;
      border: none;
      font-size: 24px;
      line-height: 1;
      color: #999;
      cursor: pointer;
    }
  }
  
  .modal-body {
    padding: 20px;
  }
}
</style>